<template>
  <div class="course-list">
    <dv-scroll-board v-if="config.data.length" :config="config" />
  </div>
</template>

<script>
import { getCourseDataApi } from '@/api/school'
export default {
  name: 'SubCourse',
  data () {
    return {
      config: {
        header: ['名称', '报名数', '观看数'],
        headerBGC: '#121a5a',
        data: [
          
        ],
        index: false,
        headerHeight: 30,
        columnWidth: [150],
        align: ['center']
      }
    }
  },
  props: {
    schoolId: Number
  },
  mounted () {
    this.getData()
  },
  methods: {
    getData () {
      getCourseDataApi({ schoolId: this.schoolId }).then(res => {
        let data = res.result.map(item => {
          return [item.name, item.signCount, item.viewCount]
        })
        this.$set(this.config, 'data', data)
        setTimeout(this.getData, 60000)
      })
    }
  }
}
</script>

<style lang="less">

.course-list {
    width: 94%;
    height: 100%;
    border-radius: 5px;
    overflow: auto;
    margin-top: 10px;
}
</style>
